<template lang="pug">
.tagComponent(
  :class="[`_${variant}`]"
) {{ label }}
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    // blue | red | green
    variant: {
      type: String,
      default: 'blue'
    }
  }
}
</script>

<style lang="sass" scoped>
.tagComponent
  @include font('t14-regular')
  width: fit-content
  padding: 2*$u 2.5*$u
  border-radius: 99em

  &._blue
    background-color: $cHtBlue
    color: $cBlue

  &._green
    background-color: $cHtGreen
    color: $cGreen

  &._red
    background-color: $cHtOrange
    color: $cOrange
</style>
